import { c as _c } from "react/compiler-runtime";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
interface WaveDropsTypingIndicatorProps {
  readonly typingMessage: string | null;
}
export const WaveDropsTypingIndicator: React.FC<WaveDropsTypingIndicatorProps> = t0 => {
  const $ = _c(8);
  const {
    typingMessage
  } = t0;
  const visibilityClass = typingMessage ? "tw-opacity-100 tw-visible" : "tw-opacity-0 tw-invisible";
  const t1 = `tw-absolute tw-bottom-0 tw-left-0 tw-z-10 tw-inset-x-0 tw-mr-2 tw-px-4 tw-pb-1.5 tw-pt-1.5 tw-flex tw-items-center tw-gap-x-2 tw-transition-opacity tw-duration-300 tw-ease-in-out tw-bg-gradient-to-t tw-from-iron-950 tw-via-iron-950/90 tw-to-transparent ${visibilityClass}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faCircle} className="tw-text-iron-300 tw-h-1 tw-w-1 tw-animate-pulse" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faCircle} className="tw-text-iron-400 tw-h-1 tw-w-1 tw-animate-pulse" style={{
      animationDelay: "150ms"
    }} />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-flex tw-items-center tw-gap-x-0.5">{t2}{t3}<FontAwesomeIcon icon={faCircle} className="tw-text-iron-500 tw-h-1 tw-w-1 tw-animate-pulse" style={{
        animationDelay: "300ms"
      }} /></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== typingMessage) {
    t5 = <span className="tw-text-xs tw-text-iron-400">{typingMessage}</span>;
    $[3] = typingMessage;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t1 || $[6] !== t5) {
    t6 = <div className={t1}>{t4}{t5}</div>;
    $[5] = t1;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};